import { IItem, IRowCards } from './types';
import FullCard from './Card';
import cn from 'classnames';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapRowCards } from './mapRowCards';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { PrismicTitle } from '@components/PrismicTitle';
import { isFilled } from '@prismicio/client';

// TODO: Once MR validated, publish changes made in "Subscription Payment", "ShopHomePageNonMember" for DE in prismic

const RowCards: React.FC<IRowCards> = ({
  items,
  overflowBehavior,
  title,
  titleStyle,
  titleDecoration,
}) => {
  return (
    <>
      <section>
        <div
          className={cn(
            'tw-flex tw-items-baseline tw-justify-center tw-gap-4',
            isFilled.richText(title) ? 'tw-mb-[--space-5]' : '',
          )}
        >
          <div className="tw-text-center">
            <PrismicTitle field={title} titleStyleField={titleStyle} />
          </div>
          {titleDecoration?.url && (
            <ResponsiveImage
              src={titleDecoration.url}
              alt={titleDecoration.alt as string}
              width={titleDecoration.dimensions.width}
              height={titleDecoration.dimensions.height}
            />
          )}
        </div>
        <div
          className={cn(
            'tw-m-[--negative-padding-layout-base] tw-flex tw-gap-[--space-5] tw-px-[--space-4] desktop:tw-m-0 desktop:tw-p-0',
            overflowBehavior === 'scroll'
              ? 'tw-overflow-x-auto'
              : 'tw-justify-center desktop:tw-justify-normal',
            !overflowBehavior || overflowBehavior === 'wrap'
              ? 'tw-flex-wrap'
              : 'tw-flex-nowrap',
          )}
        >
          {items.map((item: IItem, index: number) => {
            return (
              <div className="card" key={`row-card-${index}`}>
                <FullCard item={item} />
              </div>
            );
          })}
        </div>
      </section>
      <style jsx>{`
        .card {
          flex: 1;
        }

        .card :global(.container) {
          height: 100%;
        }

        @media (max-width: 800px) {
          .card {
            width: 70vw;
            max-width: 282px;
            min-width: ${overflowBehavior === 'scroll' ? '0' : '240px'};
            flex: ${overflowBehavior === 'scroll' ? 'auto' : '1'};
            flex-shrink: 0;
          }
        }
      `}</style>
    </>
  );
};

export default withSlice(RowCards, mapRowCards);
